<script setup>
import { useI18n } from 'vue-i18n'
import DriverPortalLayout from '@/Layouts/DriverPortalLayout.vue'
import { Link } from '@inertiajs/vue3'
import { useCurrency } from '@/composables/useCurrency.js'

defineOptions({ layout: DriverPortalLayout })
const { t } = useI18n()
const { formatMoney, formatDate } = useCurrency()

defineProps({ payouts: { type: Array, default: () => [] } })
</script>

<template>
  <h1 class="title">{{ t('driver_portal.payouts.title') }}</h1>

  <div v-if="payouts.length === 0" class="empty">
    {{ t('driver_portal.payouts.empty') }}
  </div>

  <ul v-else class="payout-list">
    <li v-for="p in payouts" :key="p.id" class="payout-row">
      <Link :href="`/payouts/${p.id}`" class="payout-row__inner">
        <div class="payout-row__left">
          <div class="payout-row__date fw-value">{{ formatDate(p.paid_at) }}</div>
          <div class="payout-row__meta">
            {{ p.method }} · {{ p.delivery_count }} {{ t('driver_portal.payouts.delivery_count') }}
          </div>
        </div>
        <span class="payout-row__amount fw-value tabular-nums">{{ formatMoney(p.amount_cents) }}</span>
      </Link>
    </li>
  </ul>
</template>

<style scoped>
.title { font-size: 1.5rem; font-weight: 700; margin: 0 0 1.25rem; color: var(--ink); }
.empty {
  text-align: center;
  padding: 3rem 1rem;
  color: var(--muted);
  font-size: 0.9375rem;
}
.payout-list { list-style: none; margin: 0; padding: 0; }
.payout-row { margin-bottom: 0.5rem; }
.payout-row__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: 0.75rem;
  text-decoration: none;
  color: var(--ink);
  transition: background 0.15s;
}
.payout-row__inner:hover { background: var(--surfaceAlt); }
.payout-row__left { min-width: 0; }
.payout-row__date { font-size: 0.9375rem; }
.payout-row__meta { font-size: 0.8125rem; color: var(--muted); margin-top: 0.1rem; }
.payout-row__amount { font-size: 1.0625rem; color: var(--ok); flex-shrink: 0; margin-left: 0.75rem; }
</style>
